/**
 * Lien vers le dashboard Cloud Monitoring d'une appliance, filtré sur son device_id et son org_id.
 * Dashboard et projet GMP : voir GMP_DASHBOARD.md.
 */
const MONITORING_DASHBOARD_ID = '1c129a82-233b-431d-be68-a18df25efbe0';
const MONITORING_PROJECT_ID = 'nm-platform-prod-d26f';

export function monitoringUrl(deviceId: string, orgId: string): string {
  const filters = [
    `type:mlabel,key:device_id,val:${encodeURIComponent(deviceId)}`,
    `type:mlabel,key:org_id,val:${encodeURIComponent(orgId)}`,
  ].join('%2B');
  return `https://console.cloud.google.com/monitoring/dashboards/builder/${MONITORING_DASHBOARD_ID};filters=${filters};duration=PT1H?project=${MONITORING_PROJECT_ID}&supportedpurview=project`;
}
